<app-organization-menu [id]="currentOrganizationId"></app-organization-menu>
<div class="container pt-4" style="padding-bottom: 150px;">
    <h4 class="border-bottom pb-2 color-primary mb-3">
        {{'ORGANIZATION.FACILITIES.title' | translate}}
        <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
            {{'ORGANIZATION.FACILITIES.titleDescription' | translate}}
        </small>
    </h4>
    <div class="row">
        <div class="col">
            <form #facilitisForm="ngForm" id="facilitisForm" (ngSubmit)="onFormSubmit()" [formGroup]="formGroup"
                class="mt-3">
                <div class="card-group" *ngIf='currentOrganizationType == 1'>
                    <div class="card">
                      <img src="assets/facilities-icons/parking.png" class="card-img-top p-5" alt="...">
                      <div class="card-body">
                          <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasParking' | translate}}</h6>
                      </div>
                      <div class="card-footer text-center">
                          <div class="custom-control custom-switch">
                              <input type="checkbox" class="custom-control-input" formControlName="hasParking">
                              <label class="custom-control-label" for="hasParking"></label>
                          </div>
                      </div>
                    </div>
                    <div class="card">
                      <img src="assets/facilities-icons/handicap.png" class="card-img-top p-5" alt="...">
                      <div class="card-body">
                          <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasHandicapFriendly' | translate}}</h6>
                      </div>
                      <div class="card-footer text-center">
                          <div class="custom-control custom-switch">
                              <input type="checkbox" class="custom-control-input" formControlName="hasHandicapFriendly">
                              <label class="custom-control-label" for="hasHandicapFriendly"></label>
                          </div>
                      </div>
                    </div>
                    <div class="card">
                      <img src="assets/facilities-icons/gastronomic-offer.png" class="card-img-top p-5" alt="...">
                      <div class="card-body">
                          <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasGastronomicOffer' | translate}}</h6>
                      </div>
                      <div class="card-footer text-center">
                          <div class="custom-control custom-switch">
                              <input type="checkbox" class="custom-control-input" formControlName="hasGastronomicOffer"
                                  id="hasGastronomicOffer">
                              <label class="custom-control-label" for="hasGastronomicOffer"></label>
                          </div>
                      </div>
                    </div>
                    <div class="card">
                      <img src="assets/facilities-icons/lifebuoy.png" class="card-img-top p-5" alt="...">
                      <div class="card-body">
                          <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasLifeguard' | translate}}</h6>
                      </div>
                      <div class="card-footer text-center">
                          <div class="custom-control custom-switch">
                              <input type="checkbox" class="custom-control-input" formControlName="hasLifeguard"
                                  id="hasLifeguard">
                              <label class="custom-control-label" for="hasLifeguard"></label>
                          </div>
                      </div>
                    </div>
                    <div class="card">
                      <img src="assets/facilities-icons/heated_pool.png" class="card-img-top p-5" alt="...">
                      <div class="card-body">
                          <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasHeatedPool' | translate}}</h6>
                      </div>
                      <div class="card-footer text-center">
                          <div class="custom-control custom-switch">
                              <input type="checkbox" class="custom-control-input" formControlName="hasHeatedPool"
                                  id="hasHeatedPool">
                              <label class="custom-control-label" for="hasHeatedPool"></label>
                          </div>
                      </div>
                    </div>
                    <div class="card">
                      <img src="assets/facilities-icons/child-friendly.png" class="card-img-top p-5" alt="...">
                      <div class="card-body">
                          <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasChildFriendlySwimmingPool' | translate}}</h6>
                      </div>
                      <div class="card-footer text-center">
                          <div class="custom-control custom-switch">
                              <input type="checkbox" class="custom-control-input" formControlName="hasChildFriendlySwimmingPool"
                                  id="hasChildFriendlySwimmingPool">
                              <label class="custom-control-label" for="hasChildFriendlySwimmingPool"></label>
                          </div>
                      </div>
                    </div>
                    <div class="card">
                      <img src="assets/facilities-icons/amusement_park.png" class="card-img-top p-5" alt="...">
                      <div class="card-body">
                          <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasChildrensPlayground' | translate}}</h6>
                      </div>
                      <div class="card-footer text-center">
                          <div class="custom-control custom-switch">
                              <input type="checkbox" class="custom-control-input" formControlName="hasChildrensPlayground"
                                  id="hasChildrensPlayground">
                              <label class="custom-control-label" for="hasChildrensPlayground"></label>
                          </div>
                      </div>
                    </div>
                </div>
                <div class="card-group" *ngIf='currentOrganizationType == 1'>
                  <div class="card">
                    <img src="assets/facilities-icons/waterslide.png" class="card-img-top p-5" alt="...">
                    <div class="card-body">
                        <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasWaterSlide' | translate}}</h6>
                    </div>
                    <div class="card-footer text-center">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" formControlName="hasWaterSlide"
                                id="hasWaterSlide">
                            <label class="custom-control-label" for="hasWaterSlide"></label>
                        </div>
                    </div>
                  </div>
                  <div class="card">
                    <img src="assets/facilities-icons/pool.png" class="card-img-top p-5" alt="...">
                    <div class="card-body">
                        <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasSwimLanes' | translate}}</h6>
                    </div>
                    <div class="card-footer text-center">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" formControlName="hasSwimLanes"
                                id="hasSwimLanes">
                            <label class="custom-control-label" for="hasSwimLanes"></label>
                        </div>
                    </div>
                  </div>
                  <div class="card">
                    <img src="assets/facilities-icons/umbrella.png" class="card-img-top p-5" alt="...">
                    <div class="card-body">
                        <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasLoungerUmbrellaHire' | translate}}</h6>
                    </div>
                    <div class="card-footer text-center">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" formControlName="hasLoungerUmbrellaHire"
                                id="hasLoungerUmbrellaHire">
                            <label class="custom-control-label" for="hasLoungerUmbrellaHire"></label>
                        </div>
                    </div>
                  </div>
                  <div class="card">
                    <img src="assets/facilities-icons/volleyball_ball.png" class="card-img-top p-5" alt="...">
                    <div class="card-body">
                        <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasVolley' | translate}}</h6>
                    </div>
                    <div class="card-footer text-center">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" formControlName="hasVolley"
                                id="hasVolley">
                            <label class="custom-control-label" for="hasVolley"></label>
                        </div>
                    </div>
                  </div>
                  <div class="card">
                    <img src="assets/facilities-icons/boathire.png" class="card-img-top p-5" alt="...">
                    <div class="card-body">
                        <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasPedalBoatHire' | translate}}</h6>
                    </div>
                    <div class="card-footer text-center">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" formControlName="hasPedalBoatHire"
                                id="hasPedalBoatHire">
                            <label class="custom-control-label" for="hasPedalBoatHire"></label>
                        </div>
                    </div>
                  </div>
                  <div class="card">
                    <img src="assets/facilities-icons/shop.png" class="card-img-top p-5" alt="...">
                    <div class="card-body">
                        <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasShopLido' | translate}}</h6>
                    </div>
                    <div class="card-footer text-center">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" formControlName="hasShop">
                            <label class="custom-control-label" for="hasShop"></label>
                        </div>
                    </div>
                  </div>
                  <div class="card">
                    <img src="assets/facilities-icons/dogs-allowed.png" class="card-img-top p-5" alt="...">
                    <div class="card-body">
                        <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasDogsAllowed' | translate}}</h6>
                    </div>
                    <div class="card-footer text-center">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" formControlName="hasDogsAllowed"
                                id="hasDogsAllowed">
                            <label class="custom-control-label" for="hasDogsAllowed"></label>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="card-group" *ngIf='currentOrganizationType == 2'>
                    <div class="card">
                        <img src="assets/facilities-icons/hasAudioGuide.png" class="card-img-top p-5" alt="...">
                        <div class="card-body">
                            <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasAudioGuide' | translate}}</h6>
                        </div>
                        <div class="card-footer text-center">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" formControlName="hasAudioGuide"
                                    id="hasAudioGuide">
                                <label class="custom-control-label" for="hasAudioGuide"></label>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <img src="assets/facilities-icons/hasBar.png" class="card-img-top p-5" alt="...">
                        <div class="card-body">
                            <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasBar' | translate}}</h6>
                        </div>
                        <div class="card-footer text-center">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" formControlName="hasBar"
                                    id="hasBar">
                                <label class="custom-control-label" for="hasBar"></label>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <img src="assets/facilities-icons/hasFamilyFriendly.png" class="card-img-top p-5" alt="...">
                        <div class="card-body">
                            <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasFamilyFriendly' | translate}}</h6>
                        </div>
                        <div class="card-footer text-center">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" formControlName="hasFamilyFriendly"
                                    id="hasFamilyFriendly">
                                <label class="custom-control-label" for="hasFamilyFriendly"></label>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <img src="assets/facilities-icons/hasHandicapFriendly.png" class="card-img-top p-5" alt="...">
                        <div class="card-body">
                            <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasHandicapFriendly' | translate}}</h6>
                        </div>
                        <div class="card-footer text-center">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input"
                                    formControlName="hasHandicapFriendly" id="hasHandicapFriendly">
                                <label class="custom-control-label" for="hasHandicapFriendly"></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-group mt-1" *ngIf='currentOrganizationType == 2'>
                    <div class="card">
                        <img src="assets/facilities-icons/hasMobileCard.png" class="card-img-top p-5" alt="...">
                        <div class="card-body">
                            <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasMobileCard' | translate}}</h6>
                        </div>
                        <div class="card-footer text-center">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" formControlName="hasMobileCard"
                                    id="hasMobileCard">
                                <label class="custom-control-label" for="hasMobileCard"></label>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <img src="assets/facilities-icons/hasParking.png" class="card-img-top p-5" alt="...">
                        <div class="card-body">
                            <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasParking' | translate}}</h6>
                        </div>
                        <div class="card-footer text-center">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" formControlName="hasParking"
                                    id="hasParking">
                                <label class="custom-control-label" for="hasParking"></label>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <img src="assets/facilities-icons/hasSchoolOffers.png" class="card-img-top p-5" alt="...">
                        <div class="card-body">
                            <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasSchoolOffers' | translate}}</h6>
                        </div>
                        <div class="card-footer text-center">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" formControlName="hasSchoolOffers"
                                    id="hasSchoolOffers">
                                <label class="custom-control-label" for="hasSchoolOffers"></label>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <img src="assets/facilities-icons/hasShop.png" class="card-img-top p-5" alt="...">
                        <div class="card-body">
                            <h6 class="card-title">{{'ORGANIZATION.FACILITIES.hasShop' | translate}}</h6>
                        </div>
                        <div class="card-footer text-center">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" formControlName="hasShop"
                                    id="hasShop">
                                <label class="custom-control-label" for="hasShop"></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center mt-3">
                    <button type="submit" class="btn btn-sm btn-outline-primary">
                        {{'GENERAL.save' | translate}}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
<app-toast></app-toast>
